import React from "react";
import { Row, Col, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FormControl } from "react-bootstrap";
import Background from '../../../assets/Images/Banner/base.png';
export default function Successo() {
    return (
        <>
            <div className="peopleSayBgColor">
                <div className="startToday spacing">
                    <div className="container" data-aos="zoom-in">
                        <div className="titleFont text-center">
                            <h2>Tutto ciò di cui si ha bisogno per operare con successo</h2>
                        </div>
                        <div className="text-center">
                        Ci distinguiamo per l'efficacia e la rapidità del servizio, con una logistica ben organizzata e tempi di attesa ridotta al minimo. Il nostro personale esperto offre consulenza, suggerimenti e assistenza personalizzata, per ottimizzare gli acquisti
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
